import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  moreAbout: {
    color: colors.blue.l60,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  listingFont: {
    fontWeight: 500,
    fontSize: '14px',
    color: colors.gray.l45,
  },
  profileAboutSection: {
    borderTop: `1px solid ${colors.gray.l94}`,
    padding: '16px 24px',
  },
  profileAboutSectionHeight: {
    height: '68px',
  },
  about: {
    wordBreak: 'break-word',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    color: colors.gray.l40,
  },
  truncatedText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
  },
});
